import { render, staticRenderFns } from "./search.vue?vue&type=template&id=6b3a1728&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3a1728",
  null
  
)

export default component.exports